import styled, { css } from "styled-components";
import { Variants } from "@dhl-official/stencil-library";
import PropTypes from "prop-types";

const Label = styled.label`
  ${({ isInvalid, shouldHide, variantType, isRequired }) => {
    const isStatic = variantType === Variants.static;

    return css`
      ${isRequired &&
      css`
        &:after {
          color: var(--dui-color-red-500);
          content: " *";
        }
      `};
      box-sizing: border-box;
      color: ${isInvalid
        ? "var(--dui-color-red-500)"
        : "var(--dui-color-gray-600)"};
      font-family: var(--dui-font-family);
      font-size: ${isStatic
        ? "var(--dui-size-font-xs) !important"
        : "var(--dui-size-font-md) !important"};
      left: 1px;
      line-height: var(--dui-size-line-height-sm);
      opacity: ${shouldHide ? 0 : 1};
      overflow: hidden;
      padding-left: var(--dui-size-space-7x);
      padding-right: var(--dui-size-space-16x);
      padding-top: var(--dui-size-space-4x);
      pointer-events: none;
      position: absolute;
      text-overflow: ellipsis;
      top: 1px;

      /* There is an offset in the animated label becase we animate it up when the user focus on the input field */
      transform: translateY(${isStatic ? 0 : "8px"});

      transition: color var(--dui-duration-3x), transform var(--dui-duration-3x),
        font-size var(--dui-duration-3x), opacity var(--dui-duration-3x);
      white-space: nowrap;
      width: 100%;
    `;
  }}
`;

Label.defaultProps = {
  isInvalid: false,
  shouldHide: false,
  variantType: Variants.static,
  isRequired: false,
};

Label.propTypes = {
  /** An **optional** prop to flag the Label component as invalid state when validation fails */
  isInvalid: PropTypes.bool,
  /** An **optional** prop to flag the Label component to set its variant behaviour */
  variantType: PropTypes.oneOf([Variants.animated, Variants.static]),
  /** An **optional** prop to flag the Label component to append * after the label text */
  isRequired: PropTypes.bool,
  /** An **optional** prop to flag the Label component to specify if its visible by default */
  shouldHide: PropTypes.bool,
};

export default Label;
